<template>
  <div>
        <el-card v-loading="startLoading" element-loading-text="正在进行第一次扫描，请稍后" class="box-card" style="">
      <div class="class1">自动防护</div>     
      <div class="text">开启自动防护之后，我们会定期对您所有的二维码进行安全检测，若在检测过程中发现任何漏洞或危险将在第一时间通过邮件通知您，保证您的所有美钥码处在安全的状态下。</div>
    <el-button class="button2" @click="startProtect()"><span v-if="alreadyStarted === 0"><i class="fa fa-shield"></i>开启自动防护</span><span v-else-if="alreadyStarted === 1">已开启，正在保护中</span></el-button>
    <div v-if="alreadyStarted === 1">上次扫描时间：{{lastCheckDate}} <el-button @click="getCheckResult(true)" style="margin-top:10px;">立刻扫描</el-button></div>
    <div v-if="alreadyStarted === 1" style="margin-top:10px;"><span class="closeProtect" @click="closeProtect()">关闭保护</span></div>
    <el-table v-if="checkResultDataSeen" :data="checkResultData" v-loading="checkResultDataLoading" element-loading-text="正在检测，结果获取中，请稍后" style="margin-top:40px;">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form inline class="form_class">
          <el-form-item label="美钥码ID">{{props.row.qrid}}</el-form-item>
          <el-form-item label="美钥码名称">{{props.row.qrname}}</el-form-item>
          <el-form-item label="美钥码链接">{{props.row.url}}</el-form-item>
          <el-form-item label="扫描结果">{{props.row.resultText}}</el-form-item>
          <div v-if="props.row.resultText === '正常'">
          <el-table :data="props.row.result">
          <el-table-column prop="item" label="检测项目" width="180"></el-table-column>
          <el-table-column prop="socer" label="得分" width="180"></el-table-column>
          <el-table-column prop="trust" label="可信度" width="180"></el-table-column>
          </el-table>
          </div>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="美钥码ID" prop="qrid"></el-table-column>
      <el-table-column label="美钥码名称" prop="qrname"></el-table-column>
      <el-table-column label="检测结果" prop="resultText"></el-table-column>
    </el-table>
    </el-card>
        <el-card class="box-card" style="">
      <span class="class1">美钥码修改记录</span>
      <el-table :data="displayData" style="width:100%;margin-top:20px;" :default-sort="{prop: 'time', order: 'descending'}" max-height="500">
        <el-table-column prop="qrid" label="美钥码ID" width="120" sortable></el-table-column>
        <el-table-column prop="date" label="修改时间" width="180" sortable></el-table-column>
        <el-table-column prop="type" label="修改类型" width="180" sortable></el-table-column>
        <el-table-column prop="oldData" label="修改前" width="280" sortable></el-table-column>
        <el-table-column prop="newData" label="修改后" width="280" sortable></el-table-column>
      </el-table>
    </el-card>
    <selectQrDialog :dialog="selectQrDialogOption"></selectQrDialog>
    <div style="text-align:center;">
      <el-pagination
        layout="prev, pager, next"
        :total="modifyData0.length"
        page-size="3"
        @current-change="currentChange">
      </el-pagination>
      </div>
  </div>
</template>


<script>
import $ from 'jquery'
export default {
  data () {
    return {
      qrs: undefined,
      modifyData0: [],
      // modifyData1: [],
      checkResultData: [],
      checkAllResultData: [],
      selectedQrid: '',
      checkResult: '',
      resultSeen: false,
      checkResultDataSeen: false,
      checkResultDataLoading: true,
      checkAllResultDataLoading: false,
      alreadyStarted: 0,
      lastCheckDate: '',
      userMessage: '',
      startLoading: false,
      // 扫描结果当前页
      currentPage: 1
    }
  },
  computed: {
    displayData: function () {
      const vm = this
      let i = (vm.currentPage - 1) * 3
      let result = []
      while (vm.modifyData0.length > i && i - (vm.currentPage - 1) * 3 < 3) {
        result.push(vm.modifyData0[i])
        i = i + 1
      }
      return result
    }
  },
  methods: {
    startProtect () {
      const vm = this
      if (vm.alreadyStarted === 1) {
        vm.$message.info('已经开启，无需重复开启')
      } else {
        if (this.userMessage.level === '1' || this.userMessage.level === '6') {
          this.$message.info('基础版及以上可以开启此功能，请升级套餐')
        } else {
          vm.startLoading = true
          $.ajax({
            type: 'POST',
            url: '/v1/security/startProtect',
            data: {type: vm.alreadyStarted},
            dataType: 'json',
            success: function () {
              // setTimeout(vm.reloadPage, 2000)
              window.location.reload()
            }
          })
        }
      }
    },
    closeProtect () {
      const vm = this
      vm.$confirm('关闭后将无法对美钥码进行实时监控，是否确认？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'}).then(() => {
          $.ajax({
            type: 'POST',
            url: '/v1/security/closeProtect',
            data: {},
            dataType: 'json',
            success: function () {
              window.location.reload()
            }
          })
        })
    },
    getCheckResult (refresh) {
      const vm = this
      vm.checkResultDataLoading = true
      $.ajax({
        type: 'GET',
        url: '/v1/security/getCheckResult',
        data: {refresh: refresh}, // 表示是直接获取数据还是从新扫描再获取
        dataType: 'json',
        success: function (response) {
          if (response.code === 200) {
            if (response.data === '-1') { // 链接无法联通

            } else {
              if (response.error === '0') {
                vm.alreadyStarted = 2
              } else {
                vm.alreadyStarted = 1
              }
              vm.lastCheckDate = response.msg
              let temp = response.data
              for (let i = 0; i < temp.length; i++) {
                temp[i].qrid = vm.getNewQrId(temp[i].qrid, temp[i].qrtype)
              }
              vm.checkResultData = temp
              vm.checkResultDataLoading = false
              vm.checkResultDataSeen = true
            }
          }
        }
      })
    },
    currentChange (p) {
      const vm = this
      vm.currentPage = p
    }
  },
  mounted () {
    document.title = '美钥二维码 - 安全中心'
    const vm = this
    $.ajax({
      type: 'GET',
      url: '/v1/userMessage',
      data: {},
      dataType: 'json',
      success: function (response) {
        vm.userMessage = response.data
      }
    })
    $.ajax({
      type: 'GET',
      url: '/v1/security/modifyHistory',
      data: '',
      dataType: 'json',
      success: function (response) {
        vm.modifyData0 = []
        for (let i = 0; i < response.data.length; i++) {
          response.data[i].qrid = vm.getNewQrId(response.data[i].qrid, response.data[i].qrtype)
          if (response.data[i].type === 0) {
            response.data[i].type = '美钥码名称修改'
          } else if (response.data[i].type === 1) {
            response.data[i].type = '网址美钥码链接修改'
          } else if (response.data[i].type === 2) {
            response.data[i].type = '文本美钥码内容修改'
            response.data[i].oldData = '(大小)' + String(response.data[i].oldData) + 'B'
            response.data[i].newData = '(大小)' + String(response.data[i].newData) + 'B'
          }
          vm.modifyData0.push(response.data[i])
        }
      }
    })
    vm.getCheckResult(false)
  }
}
</script>

<style scoped>
.box-card {
  margin: 1% 1%;
}
.class1 {
  line-height: 20px;
  font-size: 24px;
}
.button {
    width:300px;
  height: 50px;
  border: 1px solid #fe816d;
  background: #fe816d;
  color: white;
  font-size: 20px;
  border-radius: 30px;
  padding-left: 20px;
  letter-spacing: 8px;
  font-weight: 100;
}
.button:hover {
  background: #f4584d;
  border: 1px solid #f4584d;
  color: white;
}
.button2 {
  width: auto;
  border-radius: 0;
  margin-top: 20px;
}
.button2 :active {
}
.button_search {
  background: #fe816d;
  color: white;
}
.button_search:hover {
    background: #f4584d;
  border: 1px solid #f4584d;
  color: white;
}
.text {
  color:#aaaaaa;margin-top:20px;
}
.form_class {
  width: 50%;
  margin-left: 25%;
}
.form_class .el-form-item {
  width: 45%;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
}
.closeProtect:hover {
  cursor: pointer;
}
.closeProtect {
  color: red;
}
</style>
